import { createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"

const _hoisted_1 = {
  class: "min-h-screen",
  "data-theme": "amber"
}
const _hoisted_2 = { class: "max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8" }
const _hoisted_3 = { class: "flex items-center justify-between mb-8" }
const _hoisted_4 = { class: "text-2xl font-bold text-gray-900" }
const _hoisted_5 = { class: "mb-6 bg-white rounded-xl shadow-sm border border-gray-200 p-4" }
const _hoisted_6 = { class: "flex flex-wrap items-center gap-4" }
const _hoisted_7 = { class: "flex items-center gap-2" }
const _hoisted_8 = { class: "text-xs text-gray-500" }
const _hoisted_9 = { value: "" }
const _hoisted_10 = { value: "wear" }
const _hoisted_11 = { value: "nutrition" }
const _hoisted_12 = { value: "equipment" }
const _hoisted_13 = { value: "other" }
const _hoisted_14 = { class: "flex items-center gap-2" }
const _hoisted_15 = { class: "text-xs text-gray-500" }
const _hoisted_16 = ["placeholder"]
const _hoisted_17 = { class: "flex items-center gap-2" }
const _hoisted_18 = { class: "text-xs text-gray-500" }
const _hoisted_19 = { value: "" }
const _hoisted_20 = ["value"]
const _hoisted_21 = { class: "text-xs text-gray-400 ml-auto" }
const _hoisted_22 = { class: "mb-8 bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden map-container" }
const _hoisted_23 = {
  ref: "mapContainer",
  style: {"height":"320px","width":"100%"}
}
const _hoisted_24 = {
  key: 1,
  class: "text-center py-12 text-gray-500"
}
const _hoisted_25 = { class: "grid gap-4" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "flex items-center justify-between gap-4" }
const _hoisted_28 = ["src"]
const _hoisted_29 = { class: "flex-1 min-w-0" }
const _hoisted_30 = { class: "flex items-center gap-2 mb-2" }
const _hoisted_31 = ["href"]
const _hoisted_32 = {
  key: 0,
  class: "inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800"
}
const _hoisted_33 = {
  key: 1,
  class: "inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800"
}
const _hoisted_34 = {
  key: 0,
  class: "flex flex-wrap gap-1.5 mb-2"
}
const _hoisted_35 = {
  key: 1,
  class: "text-xs text-gray-400 mb-1"
}
const _hoisted_36 = ["href"]
const _hoisted_37 = ["onClick"]
const _hoisted_38 = ["onClick"]
const _hoisted_39 = ["onClick"]
const _hoisted_40 = { class: "bg-white rounded-xl shadow-xl w-full max-w-md mx-4 p-6 max-h-[90vh] overflow-y-auto" }
const _hoisted_41 = { class: "text-lg font-bold text-gray-900 mb-6" }
const _hoisted_42 = {
  key: 0,
  class: "mb-4 bg-red-50 border border-red-200 rounded-lg px-4 py-3"
}
const _hoisted_43 = { class: "block text-sm font-medium text-gray-700 mb-1" }
const _hoisted_44 = { class: "block text-sm font-medium text-gray-700 mb-1" }
const _hoisted_45 = { value: "wear" }
const _hoisted_46 = { value: "nutrition" }
const _hoisted_47 = { value: "equipment" }
const _hoisted_48 = { value: "other" }
const _hoisted_49 = { class: "block text-sm font-medium text-gray-700 mb-1" }
const _hoisted_50 = { class: "flex flex-wrap gap-1.5 mb-2" }
const _hoisted_51 = ["onClick"]
const _hoisted_52 = ["placeholder", "onKeydown"]
const _hoisted_53 = { class: "text-xs text-gray-400 mt-1" }
const _hoisted_54 = { class: "block text-sm font-medium text-gray-700 mb-1" }
const _hoisted_55 = { class: "block text-sm font-medium text-gray-700 mb-1" }
const _hoisted_56 = { class: "flex items-center justify-between mb-2" }
const _hoisted_57 = { class: "block text-sm font-medium text-gray-700" }
const _hoisted_58 = { class: "flex items-center justify-between mb-2" }
const _hoisted_59 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_60 = ["onClick"]
const _hoisted_61 = { class: "mb-2" }
const _hoisted_62 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_63 = { class: "grid grid-cols-2 gap-2" }
const _hoisted_64 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_65 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_66 = { class: "flex justify-end gap-3 pt-4" }
const _hoisted_67 = ["disabled"]
const _hoisted_68 = { class: "bg-white rounded-xl shadow-xl w-full max-w-sm mx-4 p-6" }
const _hoisted_69 = { class: "text-lg font-bold text-gray-900 mb-2" }
const _hoisted_70 = { class: "text-sm text-gray-600 mb-6" }
const _hoisted_71 = { class: "flex justify-end gap-3" }
const _hoisted_72 = ["disabled"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["NavBar"], {
      "signed-in": $props.signedIn,
      "user-name": $props.userName,
      "active-page": "shops"
    }, null, 8 /* PROPS */, ["signed-in", "user-name"]),
    _createCommentVNode(" Content "),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", _hoisted_4, _toDisplayString($setup.t('shops.title')), 1 /* TEXT */),
        ($props.signedIn)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: $setup.openCreateModal,
              class: "bg-blue-700 text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-blue-800 transition"
            }, _toDisplayString($setup.t('shops.create')), 1 /* TEXT */))
          : _createCommentVNode("v-if", true)
      ]),
      _createCommentVNode(" Filters "),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("label", _hoisted_8, _toDisplayString($setup.t('shops.filter_category')) + ":", 1 /* TEXT */),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($setup.filterCategory) = $event)),
              class: "text-xs border border-gray-300 rounded-lg px-2 py-1.5 focus:outline-none focus:ring-2 focus:ring-blue-500"
            }, [
              _createElementVNode("option", _hoisted_9, _toDisplayString($setup.t('shops.filter_all')), 1 /* TEXT */),
              _createElementVNode("option", _hoisted_10, _toDisplayString($setup.t('shops.category_wear')), 1 /* TEXT */),
              _createElementVNode("option", _hoisted_11, _toDisplayString($setup.t('shops.category_nutrition')), 1 /* TEXT */),
              _createElementVNode("option", _hoisted_12, _toDisplayString($setup.t('shops.category_equipment')), 1 /* TEXT */),
              _createElementVNode("option", _hoisted_13, _toDisplayString($setup.t('shops.category_other')), 1 /* TEXT */)
            ], 512 /* NEED_PATCH */), [
              [_vModelSelect, $setup.filterCategory]
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("label", _hoisted_15, _toDisplayString($setup.t('shops.filter_search')) + ":", 1 /* TEXT */),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($setup.filterSearch) = $event)),
              type: "text",
              placeholder: $setup.t('shops.filter_search_placeholder'),
              class: "text-xs border border-gray-300 rounded-lg px-2 py-1.5 w-48 focus:outline-none focus:ring-2 focus:ring-blue-500"
            }, null, 8 /* PROPS */, _hoisted_16), [
              [_vModelText, $setup.filterSearch]
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("label", _hoisted_18, _toDisplayString($setup.t('shops.filter_brand')) + ":", 1 /* TEXT */),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($setup.filterBrand) = $event)),
              class: "text-xs border border-gray-300 rounded-lg px-2 py-1.5 focus:outline-none focus:ring-2 focus:ring-blue-500"
            }, [
              _createElementVNode("option", _hoisted_19, _toDisplayString($setup.t('shops.filter_all')), 1 /* TEXT */),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.availableBrands, (b) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: b,
                  value: b
                }, _toDisplayString(b), 9 /* TEXT, PROPS */, _hoisted_20))
              }), 128 /* KEYED_FRAGMENT */))
            ], 512 /* NEED_PATCH */), [
              [_vModelSelect, $setup.filterBrand]
            ])
          ]),
          _createElementVNode("span", _hoisted_21, _toDisplayString($setup.filteredShops.length) + " / " + _toDisplayString($props.shops.length), 1 /* TEXT */)
        ])
      ]),
      _createCommentVNode(" Map "),
      _withDirectives(_createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, null, 512 /* NEED_PATCH */)
      ], 512 /* NEED_PATCH */), [
        [_vShow, $setup.allLocations.length > 0]
      ]),
      _createCommentVNode(" Flash "),
      ($setup.flash)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(['mb-4 px-4 py-3 rounded-lg text-sm', $setup.flash.type === 'success' ? 'bg-blue-100 text-blue-800' : 'bg-red-100 text-red-800'])
          }, _toDisplayString($setup.flash.message), 3 /* TEXT, CLASS */))
        : _createCommentVNode("v-if", true),
      _createCommentVNode(" List "),
      ($setup.filteredShops.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString($setup.t('shops.no_shops')), 1 /* TEXT */))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_25, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filteredShops, (shop) => {
          return (_openBlock(), _createElementBlock("div", {
            key: shop.id,
            onClick: $event => ($setup.goToShop($event, shop)),
            class: "bg-white rounded-xl shadow-sm border border-gray-200 p-6 hover:shadow-md transition cursor-pointer"
          }, [
            _createElementVNode("div", _hoisted_27, [
              (shop.logo_url)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: shop.logo_url,
                    class: "w-16 h-16 rounded-lg object-cover border border-gray-200 shrink-0"
                  }, null, 8 /* PROPS */, _hoisted_28))
                : _createCommentVNode("v-if", true),
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("a", {
                    href: `/shops/${shop.id}`,
                    class: "text-lg font-semibold text-gray-900 hover:text-blue-700"
                  }, _toDisplayString(shop.name), 9 /* TEXT, PROPS */, _hoisted_31),
                  (shop.category)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString($setup.t('shops.category_' + shop.category)), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true),
                  (shop.pending)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString($setup.t('shops.pending')), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true)
                ]),
                (shop.brands && shop.brands.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shop.brands, (b) => {
                        return (_openBlock(), _createElementBlock("span", {
                          key: b,
                          class: "inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-amber-100 text-amber-800"
                        }, _toDisplayString(b), 1 /* TEXT */))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true),
                (shop.locations && shop.locations.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shop.locations, (loc) => {
                        return (_openBlock(), _createElementBlock("p", {
                          key: loc.id
                        }, _toDisplayString([loc.name, loc.address].filter(Boolean).join(' — ')), 1 /* TEXT */))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true),
                (shop.link)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 2,
                      class: "mt-1",
                      onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
                    }, [
                      _createElementVNode("a", {
                        href: shop.link,
                        target: "_blank",
                        class: "inline-flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium text-white bg-blue-700 rounded-lg hover:bg-blue-800 transition"
                      }, [
                        _createTextVNode(_toDisplayString($setup.t('shops.visit_link')) + " ", 1 /* TEXT */),
                        _cache[11] || (_cache[11] = _createElementVNode("svg", {
                          class: "w-3.5 h-3.5",
                          fill: "none",
                          stroke: "currentColor",
                          viewBox: "0 0 24 24"
                        }, [
                          _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                          })
                        ], -1 /* CACHED */))
                      ], 8 /* PROPS */, _hoisted_36)
                    ]))
                  : _createCommentVNode("v-if", true)
              ]),
              ($props.userAdmin || shop.user_id === $props.userId)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "flex flex-col gap-2 ml-4",
                    onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
                  }, [
                    ($props.userAdmin && shop.pending)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          onClick: $event => ($setup.approveItem(shop)),
                          class: "px-3 py-1.5 text-xs font-medium text-green-700 bg-green-50 rounded-lg hover:bg-green-100 transition"
                        }, _toDisplayString($setup.t('shops.approve')), 9 /* TEXT, PROPS */, _hoisted_37))
                      : _createCommentVNode("v-if", true),
                    _createElementVNode("button", {
                      onClick: $event => ($setup.openEditModal(shop)),
                      class: "px-3 py-1.5 text-xs font-medium text-blue-700 bg-blue-50 rounded-lg hover:bg-blue-100 transition"
                    }, _toDisplayString($setup.t('shops.edit')), 9 /* TEXT, PROPS */, _hoisted_38),
                    _createElementVNode("button", {
                      onClick: $event => ($setup.confirmDelete(shop)),
                      class: "px-3 py-1.5 text-xs font-medium text-red-700 bg-red-50 rounded-lg hover:bg-red-100 transition"
                    }, _toDisplayString($setup.t('shops.delete')), 9 /* TEXT, PROPS */, _hoisted_39)
                  ]))
                : _createCommentVNode("v-if", true)
            ])
          ], 8 /* PROPS */, _hoisted_26))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ]),
    _createCommentVNode(" Create/Edit Modal "),
    ($setup.showModal)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "fixed inset-0 bg-black/50 flex items-center justify-center z-50",
          onClick: _withModifiers($setup.closeModal, ["self"])
        }, [
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("h2", _hoisted_41, _toDisplayString($setup.editing ? $setup.t('shops.edit_shop') : $setup.t('shops.new_shop')), 1 /* TEXT */),
            ($setup.formErrors.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.formErrors, (error) => {
                    return (_openBlock(), _createElementBlock("p", {
                      key: error,
                      class: "text-sm text-red-700"
                    }, _toDisplayString(error), 1 /* TEXT */))
                  }), 128 /* KEYED_FRAGMENT */))
                ]))
              : _createCommentVNode("v-if", true),
            _createElementVNode("form", {
              onSubmit: _withModifiers($setup.submitForm, ["prevent"]),
              class: "space-y-4"
            }, [
              _createElementVNode("div", null, [
                _createElementVNode("label", _hoisted_43, _toDisplayString($setup.t('shops.name')), 1 /* TEXT */),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (($setup.form.name) = $event)),
                  type: "text",
                  required: "",
                  class: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none text-sm"
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, $setup.form.name]
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("label", _hoisted_44, _toDisplayString($setup.t('shops.category')), 1 /* TEXT */),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => (($setup.form.category) = $event)),
                  class: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none text-sm"
                }, [
                  _cache[12] || (_cache[12] = _createElementVNode("option", { value: "" }, "—", -1 /* CACHED */)),
                  _createElementVNode("option", _hoisted_45, _toDisplayString($setup.t('shops.category_wear')), 1 /* TEXT */),
                  _createElementVNode("option", _hoisted_46, _toDisplayString($setup.t('shops.category_nutrition')), 1 /* TEXT */),
                  _createElementVNode("option", _hoisted_47, _toDisplayString($setup.t('shops.category_equipment')), 1 /* TEXT */),
                  _createElementVNode("option", _hoisted_48, _toDisplayString($setup.t('shops.category_other')), 1 /* TEXT */)
                ], 512 /* NEED_PATCH */), [
                  [_vModelSelect, $setup.form.category]
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("label", _hoisted_49, _toDisplayString($setup.t('shops.brands')), 1 /* TEXT */),
                _createElementVNode("div", _hoisted_50, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.form.brands, (b, idx) => {
                    return (_openBlock(), _createElementBlock("span", {
                      key: idx,
                      class: "inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium bg-amber-100 text-amber-800"
                    }, [
                      _createTextVNode(_toDisplayString(b) + " ", 1 /* TEXT */),
                      _createElementVNode("button", {
                        type: "button",
                        onClick: $event => ($setup.removeBrand(idx)),
                        class: "text-amber-700 hover:text-amber-900"
                      }, "×", 8 /* PROPS */, _hoisted_51)
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                ]),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => (($setup.brandInput) = $event)),
                  type: "text",
                  placeholder: $setup.t('shops.brand_placeholder'),
                  onKeydown: [
                    _withKeys(_withModifiers($setup.addBrand, ["prevent"]), ["enter"]),
                    $setup.onBrandKey
                  ],
                  onBlur: $setup.addBrand,
                  class: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none text-sm"
                }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_52), [
                  [_vModelText, $setup.brandInput]
                ]),
                _createElementVNode("p", _hoisted_53, _toDisplayString($setup.t('shops.brand_hint')), 1 /* TEXT */)
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("label", _hoisted_54, _toDisplayString($setup.t('shops.link')), 1 /* TEXT */),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => (($setup.form.link) = $event)),
                  type: "url",
                  placeholder: "https://...",
                  class: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none text-sm"
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, $setup.form.link]
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("label", _hoisted_55, _toDisplayString($setup.t('shops.description')), 1 /* TEXT */),
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => (($setup.form.description) = $event)),
                  rows: "3",
                  class: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none text-sm"
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, $setup.form.description]
                ])
              ]),
              _createVNode($setup["ImageUpload"], {
                modelValue: $setup.form.logo_url,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => (($setup.form.logo_url) = $event)),
                label: $setup.t('shops.logo'),
                "upload-text": $setup.t('shops.upload_logo'),
                "change-text": $setup.t('shops.change_logo'),
                "remove-text": $setup.t('shops.remove_logo'),
                "csrf-token": $props.csrfToken,
                "upload-type": "shops"
              }, null, 8 /* PROPS */, ["modelValue", "label", "upload-text", "change-text", "remove-text", "csrf-token"]),
              _createCommentVNode(" Locations "),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_56, [
                  _createElementVNode("label", _hoisted_57, _toDisplayString($setup.t('shops.locations')), 1 /* TEXT */),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: $setup.addLocation,
                    class: "text-xs text-blue-700 hover:text-blue-900 font-medium"
                  }, "+ " + _toDisplayString($setup.t('shops.add_location')), 1 /* TEXT */)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.form.locations, (loc, idx) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: idx,
                    class: "mb-3 p-3 bg-gray-50 rounded-lg border border-gray-200"
                  }, [
                    _createElementVNode("div", _hoisted_58, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": $event => ((loc.name) = $event),
                        type: "text",
                        placeholder: $setup.t('shops.location_name'),
                        class: "flex-1 px-2 py-1 border border-gray-300 rounded text-sm focus:ring-2 focus:ring-blue-500 outline-none"
                      }, null, 8 /* PROPS */, _hoisted_59), [
                        [_vModelText, loc.name]
                      ]),
                      _createElementVNode("button", {
                        type: "button",
                        onClick: $event => ($setup.removeLocation(idx)),
                        class: "ml-2 text-red-400 hover:text-red-600 text-sm"
                      }, "×", 8 /* PROPS */, _hoisted_60)
                    ]),
                    _createElementVNode("div", _hoisted_61, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": $event => ((loc.address) = $event),
                        type: "text",
                        placeholder: $setup.t('shops.address'),
                        class: "w-full px-2 py-1 border border-gray-300 rounded text-sm focus:ring-2 focus:ring-blue-500 outline-none"
                      }, null, 8 /* PROPS */, _hoisted_62), [
                        [_vModelText, loc.address]
                      ])
                    ]),
                    _createElementVNode("div", {
                      ref_for: true,
                      ref: el => { if (el) $setup.formMapRefs[idx] = el },
                      style: {"height":"150px","width":"100%"},
                      class: "rounded border border-gray-300 mb-2"
                    }, null, 512 /* NEED_PATCH */),
                    _createElementVNode("div", _hoisted_63, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": $event => ((loc.latitude) = $event),
                        type: "number",
                        step: "0.0000001",
                        readonly: "",
                        placeholder: $setup.t('shops.latitude'),
                        class: "px-2 py-1 border border-gray-300 rounded bg-gray-50 text-xs"
                      }, null, 8 /* PROPS */, _hoisted_64), [
                        [_vModelText, loc.latitude]
                      ]),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": $event => ((loc.longitude) = $event),
                        type: "number",
                        step: "0.0000001",
                        readonly: "",
                        placeholder: $setup.t('shops.longitude'),
                        class: "px-2 py-1 border border-gray-300 rounded bg-gray-50 text-xs"
                      }, null, 8 /* PROPS */, _hoisted_65), [
                        [_vModelText, loc.longitude]
                      ])
                    ])
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ]),
              _createElementVNode("div", _hoisted_66, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: $setup.closeModal,
                  class: "px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition"
                }, _toDisplayString($setup.t('shops.cancel')), 1 /* TEXT */),
                _createElementVNode("button", {
                  type: "submit",
                  disabled: $setup.submitting,
                  class: "px-4 py-2 text-sm font-medium text-white bg-blue-700 rounded-lg hover:bg-blue-800 transition disabled:opacity-50"
                }, _toDisplayString($setup.submitting ? '...' : ($setup.editing ? $setup.t('shops.save') : $setup.t('shops.create'))), 9 /* TEXT, PROPS */, _hoisted_67)
              ])
            ], 32 /* NEED_HYDRATION */)
          ])
        ]))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" Delete Modal "),
    ($setup.showDeleteModal)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "fixed inset-0 bg-black/50 flex items-center justify-center z-50",
          onClick: _withModifiers($setup.closeDeleteModal, ["self"])
        }, [
          _createElementVNode("div", _hoisted_68, [
            _createElementVNode("h2", _hoisted_69, _toDisplayString($setup.t('shops.confirm_delete')), 1 /* TEXT */),
            _createElementVNode("p", _hoisted_70, _toDisplayString($setup.t('shops.confirm_delete_message')), 1 /* TEXT */),
            _createElementVNode("div", _hoisted_71, [
              _createElementVNode("button", {
                onClick: $setup.closeDeleteModal,
                class: "px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition"
              }, _toDisplayString($setup.t('shops.cancel')), 1 /* TEXT */),
              _createElementVNode("button", {
                onClick: $setup.deleteShop,
                disabled: $setup.submitting,
                class: "px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-lg hover:bg-red-700 transition disabled:opacity-50"
              }, _toDisplayString($setup.submitting ? '...' : $setup.t('shops.delete')), 9 /* TEXT, PROPS */, _hoisted_72)
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}